(() => {
  const init = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const slides = [...root.querySelectorAll('[data-delivery-slide]')];
    const dots = [...root.querySelectorAll('[data-delivery-dot]')];
    if (slides.length < 2) return;
    let current = 0;
    let timer;
    const show = (index) => {
      current = index;
      slides.forEach((slide, i) => {
        const active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.toggleAttribute('tabindex', !active);
        if (!active) slide.setAttribute('tabindex', '-1');
      });
      dots.forEach((dot, i) => {
        const active = i === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
    };
    const start = () => {
      clearInterval(timer);
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(() => show((current + 1) % slides.length), 5000);
    };
    dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); start(); }));
    root.addEventListener('mouseenter', () => clearInterval(timer));
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', () => clearInterval(timer));
    root.addEventListener('focusout', start);
    show(0);
    start();
  };
  const initAll = (scope = document) => scope.querySelectorAll('[data-delivery-companion]').forEach(init);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
